import React, { useState } from 'react'

import { firestore } from '../../../firebase'
import AddProfileImage from './AddProfileImage'


function EditProfileImage({author}) {

    const [profileImage, setProfileImage] = useState(author.profile_image)
    const [message, setMessage] = useState("")

    async function profileImageHandler(e) {
        e.preventDefault()

        try {
            const authorRef = firestore.collection("authors").doc(author.id);

            const data = {
                profile_image: profileImage
            }
            const updatedProfile = await authorRef.update(data)
            setMessage("Updated");
        } catch (error) {
            setMessage("Error, try again")
        }

    }

    return (
        <>
        <AddProfileImage authorId={author.id} setProfileImage={setProfileImage} />
        <form onSubmit={profileImageHandler}>
            <label>Profilbilde</label>
            <input value={profileImage} onChange={e => setProfileImage(e.target.value)} className="form-control mb-2" />
            <div className="col-lg-2 col-md-6">
                <img src={profileImage} alt="profile-pic" />
            </div>
            {message && <div>{message} </div>}
            <button className="btn btn-primary">Oppdater profilbilde</button>
        </form>
        </>
    )
}
export default EditProfileImage